import Box from '@mui/material/Box';
import CircularProgress, {
	CircularProgressProps
} from '@mui/material/CircularProgress';
import type { SxProps, Theme } from '@mui/material/styles';

import { mergeSx } from '@/utils/mergeSx';

import { loadingIndicatorStyles as sx } from './LoadingIndicator.styles';

type Props = {
	size?: number;
	color?: CircularProgressProps['color'];
	customSx?: SxProps<Theme>;
};

export const LoadingIndicator = ({
	size = 40,
	color = 'primary',
	customSx
}: Props) => {
	return (
		<Box sx={mergeSx(sx.root, customSx)}>
			<CircularProgress size={size} color={color} />
		</Box>
	);
};
